import { Component, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { EnvService } from 'src/app/env.service';

@Component({
  selector: 'taly-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  transferSignal = inject(SharedSignalsService);

  appIcon:any;
  appLink:any;

  textDirection:string;
  constructor(public envService : EnvService) { 
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      const osInfo = this.transferSignal?.userAgentType();
     
      if(osInfo == 'iOS'){
        this.appIcon = 'assets/images/app-store-img.svg';
        this.appLink = envService.appIOSURL
      }else{
        this.appIcon = 'assets/images/google-play-store.svg';
        this.appLink = envService.appAndroidURL;
      }

    })
  }

  ngOnInit(): void {
  
  }
}
